import React from 'react'

function GameOver(props) {
  return (
    <div id='GameOver' style={{ fontSize: props.width / 15 }}>
      <div id='GameOverText'>GAME OVER</div>
      <div>Tu Puntaje: {props.score}</div>
      <div>
        {props.newHighScore ? 'Nuevo' : 'Antiguo '}puntaje maximo:{' '}
        {props.highScore}
      </div>
      <div id='PressSpaceText'>Presiona espacio para reiniciar</div>
    </div>
  )
}

export default GameOver
